module.exports = "/assets/site/images/2.png?4dbafe2e95c3dc1d76036f85c73eab05";